export default "__VITE_ASSET__ByVxhqdm__"